import { defineStore } from 'pinia'

/* Types */
import { StoreId } from '@/store'
import { Success } from '@/api/results'
import { BannersState } from '@/store/banners/banners.types'

export const useBannersStore = defineStore({
  id: StoreId.BANNERS,
  state: (): BannersState => {
    return {
      data: {
        banners: [],
        deliveryBackgroundBanners: [],
      },
      isLoaded: false,
      isLoading: true,
      error: null,
    }
  },
  actions: {
    setState(mainBanners: BannersState) {
      Object.assign(this.$state, mainBanners)
    },
    async fetchBanners() {
      const { $apiService } = useNuxtApp()
      const result = await $apiService.catalog.fetchBanners()

      if (result instanceof Success) {
        const sortBanners = result?.data?.sort(
          (banner1, banner2) => banner2.order - banner1.order,
        )

        const mainBanners = sortBanners?.filter(
          (banner) => banner.type === 1 && banner.image_desktop,
        )

        const deliveryBackgroundBanners = sortBanners?.filter(
          (banner) => banner.type === 2,
        )
        this.setState({
          data: {
            // @ts-ignore
            banners: mainBanners,
            // @ts-ignore
            deliveryBackgroundBanners,
          },
          isLoading: false,
          isLoaded: true,
        })
      } else {
        this.setState({
          isLoading: false,
          // @ts-ignore
          error: result,
          isLoaded: true,
        })
      }
    },
  },
})
